module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Fridge-fcb4a983a1f9bd3bc6b33ffae72604cd.svg";